export default __webpack_public_path__ + "static/media/downArrow.bc9b541d.svg";